"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.order = exports.list = exports.line = exports.createListFunc = void 0;
/**
 * Create the Markdown from the array string.
 * @param prefix The prefix string of each line.
 *
 * If omitted, its default value is empty string.
 */
const createListFunc = (prefix = '') => (
/** The strings. */
...source) => `${source
    .reduce((acc, cur) => `${acc}
${prefix}${cur}`, '')
    .trim()}
`;
exports.createListFunc = createListFunc;
/** Create the multiline from the array string. */
exports.line = exports.createListFunc();
/** Create the Markdown from the array string. */
exports.list = exports.createListFunc('- ');
/** Create the Markdown from the array string. */
exports.order = exports.createListFunc('1. ');
//# sourceMappingURL=list.js.map